import React from "react";
import UserProfileComponent from "../../components/UserProfile";
import Sidebar from "../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import * as profileActions from "../../redux/actions/profileAction";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as modalActions from "../../redux/actions/modalActions";
import { setLanguage } from "redux-i18n";
import * as commonActions from "../../redux/actions/commonAction";

export default function UserProfile(props, context) {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);

  const dispatch = useDispatch();
  let profileAction = bindActionCreators(profileActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);

  const updateManagersDetails = (managersDetails) => {
    profileAction.updateManagersDetails(managersDetails);
  };
  const uploadProfilePhoto = (profilePhoto, allDetails) => {
    profileAction.uploadProfilePhoto(profilePhoto, allDetails);
  };

  const resetProfilePhoto = () => {
    profileAction.resetProfilePhoto();
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };
  return (
    <>
    {window.location.hash !== "#/" && (
      <Sidebar
        languageChange={languageChange}
        openSetModalAction={openSetModal}
        closeRemoveModal={closeRemoveModal}
        managersDetails={profileReducer.managersDetails}
        onMenuToggle={onMenuToggle}
        isSideMenuOpen={commonReducer.isSideMenuOpen}
        context={context}
      />
    )}
    <div
      className={
        commonReducer.isSideMenuOpen ? "Content-Panel" : "Content-Panel open"
      }
    >
      
      <UserProfileComponent
        profileImageURL={commonReducer.profileImageURL}
        uploadProfilePhoto={uploadProfilePhoto}
        updateManagersDetails={updateManagersDetails}
        managersDetails={profileReducer.managersDetails}
        resetProfilePhoto={resetProfilePhoto}
        context={context}
      />
    </div>
    </>
  );
}
UserProfile.contextTypes = {
  t: PropTypes.func.isRequired,
};
